import {boot} from 'quasar/wrappers'
import {ENABLE_GTM} from '../../environment/environment'
import { uid } from 'quasar'

const gtm = {
  store: null,
  logEvent(swacEvent, extraData = {}) {
    if (!ENABLE_GTM) {
      return
    }
    if (!this.store) {
      return
    }
    const route = this.store.$router.currentRoute.value
    const isSendIds = route?.meta?.type === 'user' && route.name !== 'documents'

    dataLayer.push({
      event: 'customEvent',
      cid: this.getCid(),
      swac_user_id: this.getUserId(),
      user_id: this.getUserId(),
      organization_code: this.getOrganizationCode(),
      swac_event: swacEvent,
      node_id: isSendIds ? this.store.getters['common/nodeId'] : null,
      ...extraData,
    })
  },

  logPage() {
    if (!ENABLE_GTM) {
      return
    }

    if (!this.store) {
      return
    }
    const route = this.store.$router.currentRoute.value
    const isSendIds = route?.meta?.type === 'user' && route.name !== 'documents'

    dataLayer.push({
      event: 'customPageView',
      path: route.path,
      cid: this.getCid(),
      swac_user_id: this.getUserId(),
      user_id: this.getUserId(),
      organization_code: this.getOrganizationCode(),
      node_id: isSendIds ? this.store.getters['common/nodeId'] : null,
    })
  },

  getCid() {
      // We need an unique identifier for this session
      // We store it in a localStorage, but you may use cookies, too
      if (!localStorage.cid) {
          localStorage.cid = uid();
      }
      return localStorage.cid;
  },

  getUserId() {
      return localStorage.getItem('swac_user_id')
  },

  getOrganizationCode() {
      return localStorage.getItem('organization_code')
  }
}

export default boot(({router, store}) => {

  gtm.store = store
  router.afterEach(() => {
    gtm.logPage()
  })

})

export { gtm }
